import ApiClient from '@/services/apiClient';

// A reader with the hub (or LINK) it is wired to and the door it opens, as
// GET /facilities/{id}/readers lists them: what a room is made of.
export default class AccessReader {
    id;
    label;              // "door (reader)"
    hub_id;
    hub_label;
    reader_position;
    reader_label;
    door_id;
    door_label;

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccessReader();
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.label = ApiClient.convertToType(data['label'], 'String');
            obj.hub_id = ApiClient.convertToType(data['hub_id'], 'Integer');
            obj.hub_label = ApiClient.convertToType(data['hub_label'], 'String');
            obj.reader_position = ApiClient.convertToType(data['reader_position'], 'Integer');
            obj.reader_label = ApiClient.convertToType(data['reader_label'], 'String');
            obj.door_id = ApiClient.convertToType(data['door_id'], 'Integer');
            obj.door_label = ApiClient.convertToType(data['door_label'], 'String');
        }
        return obj;
    }

    toString() {
        return this.label;
    }
}
